<script setup>
  import { onMounted, ref } from 'vue';
  import { useMainStore } from '@/stores/main'
  import * as Server from '@/services/Server'
  import Loading from '@/components/Loading.vue';

  const store = useMainStore()
  const dashboard = ref()

  const fetch = () => {
    const path = store.apiPath.dashboard
    Server.get(path)
      .then(response => {
        dashboard.value = response.data
      })
      .catch(error => {
        console.error('Error fetching dashboard data:', error)
      })
  }

  onMounted(fetch)
</script>

<template>
  <main>
    <v-container>

      <template v-if="dashboard">
        ciao ben arrivato!
      </template>

      <Loading v-else />

    </v-container>
  </main>
</template>
